'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/components/icon';
import { MaxWidthWrapper } from '@/components/max-width-wrapper';
import { Text } from '@/components/text';
import { WatchNowButton } from '@/components/watch-now-button';
export function FiveStarRating() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Text as="h2" className="mb-8 font-black text-xl">1000+ Ratings</Text>;
    t1 = <Icon name="five-stars" className="mx-auto mb-12 h-24 w-full max-w-[750px] text-christ-red md:h-40" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="py-12 uppercase md:py-20"><MaxWidthWrapper><div className="flex flex-col items-center justify-center text-center">{t0}{t1}<Text as="p" className="mx-auto pb-8 font-extrabold font-formula-condensed text-[4rem] leading-[0.85] sm:text-[5rem] md:text-[7rem]"><span className="block whitespace-nowrap">But countless</span><span className="block whitespace-nowrap">watched it</span><span className="block whitespace-nowrap">anyway</span></Text><div><WatchNowButton /></div></div></MaxWidthWrapper></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}